import { motion } from 'framer-motion'
import Reveal from './Reveal'
import celulaImg from '../assets/celula.webp'

const cursos = [
  {
    icon: (
      <svg width="52" height="52" viewBox="0 0 52 52" fill="none" opacity="0.35">
        <path
          d="M26 10c0 0-14 8-14 18a14 14 0 0028 0C40 18 26 10 26 10z"
          stroke="#C9A84C"
          strokeWidth="1.2"
        />
        <path
          d="M26 22v8M22 26h8"
          stroke="#C9A84C"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <circle cx="26" cy="26" r="4" stroke="#C9A84C" strokeWidth="1" />
      </svg>
    ),
    name: 'Cardiología Clínica Avanzada',
    desc:
      'Domina los fundamentos y la práctica actual. Casos reales, protocolos actualizados y ECG en profundidad.',
    price: '$149 USD',
    badge: 'Más vendido',
    hotmart: '#',
    image: null,
  },

  {
    icon: null,
    image: celulaImg,
    name: 'Célula Eucariota : La base de medicina. Explicada como nunca antes',
    desc:
      'Comprendé desde cero la estructura y funcionamiento celular con una explicación visual, clínica y lógica que transforma completamente la manera de estudiar medicina.',
    price: null,
    badge: 'Nuevo',
    hotmart: 'https://go.hotmart.com/W105956014I?dp=1',
  },

  {
    icon: (
      <svg width="52" height="52" viewBox="0 0 52 52" fill="none" opacity="0.35">
        <rect
          x="17"
          y="20"
          width="18"
          height="14"
          rx="2"
          stroke="#C9A84C"
          strokeWidth="1.2"
        />
        <path
          d="M22 20v-4a4 4 0 018 0v4"
          stroke="#C9A84C"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <circle cx="26" cy="27" r="2.5" fill="#C9A84C" opacity="0.6" />
        <path
          d="M26 29.5v2"
          stroke="#C9A84C"
          strokeWidth="1"
          strokeLinecap="round"
        />
      </svg>
    ),
    name: 'Farmacología Aplicada',
    desc:
      'Lo que ningún libro explica sobre cómo elegir el fármaco correcto. Enfoque clínico, no memorístico.',
    price: '$99 USD',
    badge: null,
    hotmart: '#',
    image: null,
  },
]

export default function Cursos() {
  return (
    <section
      id="cursos"
      className="relative overflow-hidden"
      style={{
        padding: '120px 5vw',
        background: 'var(--bg-2)',
      }}
    >
      {/* Fondo */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.025]"
        style={{
          backgroundImage:
            'repeating-linear-gradient(0deg, #C9A84C 0, #C9A84C 1px, transparent 1px, transparent 80px), repeating-linear-gradient(90deg, #C9A84C 0, #C9A84C 1px, transparent 1px, transparent 80px)',
        }}
      />

      <div className="relative z-10">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
            {/* Título */}
            <div className="shrink-0">
              <div className="section-label">Cursos disponibles</div>

              <h2
                className="font-display font-black leading-[1.04] tracking-[-0.02em]"
                style={{
                  fontSize: 'clamp(2.2rem, 4vw, 3.5rem)',
                  color: 'var(--ink)',
                }}
              >
                Formación diseñada
                <br />
                para{' '}
                <em
                  className="not-italic"
                  style={{ color: 'var(--gold)' }}
                >
                  resultados reales
                </em>
                .
              </h2>
            </div>

            {/* Texto derecho */}
            <div
              className="flex flex-col gap-4 max-w-sm"
              style={{
                borderLeft: '2px solid rgba(201,168,76,0.25)',
                paddingLeft: 20,
              }}
            >
              <p
                className="font-body font-light text-[13px] leading-[1.8]"
                style={{ color: 'var(--ink-2)' }}
              >
                Cada curso está pensado como un entrenamiento: primero ordenás el tema,
                después lo razonás y finalmente lo llevás a preguntas reales.
              </p>

              <p
                className="font-body font-light text-[13px] leading-[1.8]"
                style={{ color: 'var(--ink-2)' }}
              >
                Dejás de estudiar temas aislados y empezás a ver el sistema completo:
                qué importa, cómo se conecta y cómo te lo pueden tomar.
              </p>

              <p
                className="font-body font-light text-[13px] leading-[1.8]"
                style={{ color: 'var(--ink-2)' }}
              >
                Te doy un mapa claro de qué estudiar, cómo estudiarlo, cómo razonarlo
                y cómo responder en el examen.
              </p>
            </div>
          </div>
        </Reveal>

        {/* Grid */}
        <div
          className="grid grid-cols-1 md:grid-cols-3"
          style={{
            gap: '1px',
            background: 'var(--line)',
          }}
        >
          {cursos.map((c, i) => (
            <motion.div
              key={c.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                delay: i * 0.1,
                duration: 0.7,
                ease: [0.22, 1, 0.36, 1],
              }}
              whileHover={{
                backgroundColor: 'rgba(22,22,22,1)',
              }}
              className="relative flex flex-col overflow-hidden"
              style={{
                background: 'var(--bg-2)',
              }}
            >
              {/* Header */}
              <div
                className="relative overflow-hidden"
                style={{
                  height: '320px',
                  background: 'var(--bg-3)',
                  borderBottom: '1px solid var(--line)',
                }}
              >
                {c.image ? (
                  <>
                    {/* IMAGEN AJUSTADA CORRECTAMENTE */}
                    <img
                      src={c.image}
                      alt={c.name}
                      className="absolute inset-0 w-full h-full object-contain"
                      style={{
                        objectPosition: 'center',
                        background: '#0B0B0B',
                      }}
                    />

                    {/* Overlay elegante */}
                    <div
                      className="absolute inset-0"
                      style={{
                        background:
                          'linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.12) 45%, rgba(0,0,0,0.04) 100%)',
                      }}
                    />
                  </>
                ) : (
                  <>
                    {/* Glow */}
                    <div
                      className="absolute inset-0 pointer-events-none"
                      style={{
                        background:
                          'linear-gradient(135deg, rgba(201,168,76,0.06) 0%, transparent 60%)',
                      }}
                    />

                    <div className="absolute inset-0 flex items-center justify-center">
                      {c.icon}
                    </div>
                  </>
                )}

                {/* Badge */}
                {c.badge && (
                  <div
                    className="absolute top-4 right-4 z-10 font-display font-black text-[9px] tracking-[0.12em] uppercase px-2.5 py-1.5"
                    style={{
                      background: 'var(--gold)',
                      color: '#000',
                    }}
                  >
                    {c.badge}
                  </div>
                )}
              </div>

              {/* Body */}
              <div className="flex flex-col flex-1 p-8">
                <h3
                  className="font-display font-black text-[18px] leading-[1.2] mb-2.5"
                  style={{
                    color: 'var(--ink)',
                  }}
                >
                  {c.name}
                </h3>

                <p
                  className="font-body font-light text-[13px] leading-[1.75] flex-1"
                  style={{
                    color: 'var(--ink-2)',
                  }}
                >
                  {c.desc}
                </p>

                {/* Footer */}
                <div
                  className="flex items-center justify-between mt-6 pt-5"
                  style={{
                    borderTop: '1px solid var(--line-2)',
                  }}
                >
                  {c.price ? (
                    <span
                      className="font-display font-black text-[20px]"
                      style={{
                        color: 'var(--gold)',
                      }}
                    >
                      {c.price}
                    </span>
                  ) : (
                    <div />
                  )}

                  <motion.a
                    href={c.hotmart}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-display font-black text-[10px] tracking-[0.1em] uppercase px-5 py-2.5"
                    style={{
                      background: 'var(--gold)',
                      color: '#000',
                    }}
                    whileHover={{
                      backgroundColor: '#E2C47A',
                    }}
                    transition={{ duration: 0.15 }}
                  >
                    Comprar
                  </motion.a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
